<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Принтер CS963">
     Принтер CS963
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_uk" title="Інформація про безпеку">
     Інформація про безпеку
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Умовні позначення">
      Умовні позначення
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e43" title="Заяви щодо виробу">
      Заяви щодо виробу
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_uk" title="Докладніше про принтер">
     Докладніше про принтер
    </a>
   </p>
   <div id="divd0e213">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_uk" title="Пошук інформації про принтер">
      Пошук інформації про принтер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_uk" title="Пошук серійного номера принтера">
      Пошук серійного номера принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_uk" title="Налаштування принтера">
      Налаштування принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_uk" title="Використання панелі керування">
      Використання панелі керування
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_uk" title="Піктограми головного екрана">
      Піктограми головного екрана
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_uk" title="Кольори світлового індикатора">
      Кольори світлового індикатора
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_uk" title="Розташування гнізда безпеки">
      Розташування гнізда безпеки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e715" title="Вибір паперу">
      Вибір паперу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10486" title="Додаткові функції принтера та підтримка">
      Додаткові функції принтера та підтримка
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_uk" title="Налаштування, установлення та конфігурування">
     Налаштування, установлення та конфігурування
    </a>
   </p>
   <div id="divd0e10604">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_uk" title="Вибір місця розташування для принтера">
      Вибір місця розташування для принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_uk" title="Порти принтера">
      Порти принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#d0e10784" title="Конфігурування програм і рішень">
      Конфігурування програм і рішень
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e10942" title="Налаштування та використання спеціальних можливостей">
      Налаштування та використання спеціальних можливостей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_uk" title="Завантаження паперу та спеціальних носіїв">
      Завантаження паперу та спеціальних носіїв
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11648" title="Установлення та оновлення програмного забезпечення, драйверів та мікропрограм">
      Установлення та оновлення програмного забезпечення, драйверів та мікропрограм
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e11951" title="Установлення апаратних опцій">
      Установлення апаратних опцій
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e13431" title="Мережа">
      Мережа
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_uk" title="Захист принтера">
     Захист принтера
    </a>
   </p>
   <div id="divd0e13782">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_uk" title="Стирання пам'яті принтера">
      Стирання пам'яті принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_uk" title="Стирання накопичувача принтера">
      Стирання накопичувача принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_uk" title="Відновлення заводських налаштувань за замовчуванням">
      Відновлення заводських налаштувань за замовчуванням
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_uk" title="Заява про енергозалежність">
      Заява про енергозалежність
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_uk" title="Print (Друк)">
     Print (Друк)
    </a>
   </p>
   <div id="divd0e13972">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_uk" title="Друк із комп&rsquo;ютера">
      Друк із комп&rsquo;ютера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14023" title="Друк із мобільного пристрою">
      Друк із мобільного пристрою
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_uk" title="Друк із флешнакопичувача">
      Друк із флешнакопичувача
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_uk" title="Налаштування конфіденційних завдань">
      Налаштування конфіденційних завдань
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_uk" title="Друк конфіденційних та інших відкладених завдань">
      Друк конфіденційних та інших відкладених завдань
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_uk" title="Друк списку зразків шрифтів">
      Друк списку зразків шрифтів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_uk" title="Друк списку каталогів">
      Друк списку каталогів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_uk" title="Розміщення аркушів-розділювачів у завданнях друку">
      Розміщення аркушів-розділювачів у завданнях друку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_uk" title="Скасування завдання друку">
      Скасування завдання друку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_uk" title="Коригування щільності тонера">
      Коригування щільності тонера
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_uk" title="Меню принтера">
     Меню принтера
    </a>
   </p>
   <div id="divd0e14518">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_uk" title="Карта меню">
      Карта меню
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e14826" title="Device (Пристрій)">
      Device (Пристрій)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e16736" title="Print (Друк)">
      Print (Друк)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e18017" title="Paper (Папір)">
      Paper (Папір)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e18294" title="USB Drive (USB-накопичувач)">
      USB Drive (USB-накопичувач)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e18558" title="Network/Ports (Мережа/порти)">
      Network/Ports (Мережа/порти)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e20680" title="Security (Безпека)">
      Security (Безпека)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e21744" title="Cloud Services (Хмарні служби)">
      Cloud Services (Хмарні служби)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e21801" title="Reports (Звіти)">
      Reports (Звіти)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_uk" title="Troubleshooting (Усунення несправностей)">
      <strong>
       Troubleshooting
      </strong>
      (Усунення несправностей)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_uk" title="Forms Merge (Злиття форм)">
      <strong>
       Forms Merge
      </strong>
      (Злиття форм)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_uk" title="Друк Menu Settings Page (Сторінка параметрів меню)">
      Друк
      <strong>
       Menu Settings Page
      </strong>
      (Сторінка параметрів меню)
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_uk" title="Додаткові функції фінішера принтера">
     Додаткові функції фінішера принтера
    </a>
   </p>
   <div id="divd0e22189">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_uk" title="Використання фінішера з функцією зшивання">
      Використання фінішера з функцією зшивання
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_uk" title="Використання фінішера з функцією зшивання й діркопробивачем">
      Використання фінішера з функцією зшивання й діркопробивачем
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_uk" title="Використання укладальника зі зміщенням">
      Використання укладальника зі зміщенням
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_uk" title="Використання фінішера-брошурувальника">
      Використання фінішера-брошурувальника
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_uk" title="Використання додаткового пристрою для транспортування паперу з функцією складання">
      Використання додаткового пристрою для транспортування паперу з функцією складання
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_uk" title="Технічне обслуговування принтера">
     Технічне обслуговування принтера
    </a>
   </p>
   <div id="divd0e22598">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_uk" title="Перевірка стану деталей і витратних матеріалів">
      Перевірка стану деталей і витратних матеріалів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_uk" title="Налаштування сповіщень про витратні матеріали">
      Налаштування сповіщень про витратні матеріали
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_uk" title="Налаштування оповіщень електронної пошти">
      Налаштування оповіщень електронної пошти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_uk" title="Створення звітів та журналів">
      Створення звітів та журналів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_uk" title="Замовлення запчастин і витратних матеріалів">
      Замовлення запчастин і витратних матеріалів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e23197" title="Заміна запчастин і витратних матеріалів">
      Заміна запчастин і витратних матеріалів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e23786" title="Очищення деталей принтера">
      Очищення деталей принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e23900" title="Економія енергії та паперу">
      Економія енергії та паперу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_uk" title="Переміщення принтера в інше місце">
      Переміщення принтера в інше місце
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_uk" title="Усунення несправностей">
     Усунення несправностей
    </a>
   </p>
   <div id="divd0e24035">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_uk" title="Проблема з якістю друку">
      Проблема з якістю друку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_uk" title="Коди помилок принтера">
      Коди помилок принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e25210" title="Проблеми з друком">
      Проблеми з друком
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_uk" title="Принтер не відповідає">
      Принтер не відповідає
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_uk" title="Не вдається зчитати флешнакопичувач">
      Не вдається зчитати флешнакопичувач
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_uk" title="Увімкнення порту USB">
      Увімкнення порту USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_uk" title="Усування зминання">
      Усування зминання
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e27191" title="Проблеми підключення до мережі">
      Проблеми підключення до мережі
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e27282" title="Проблеми параметрів апаратного забезпечення">
      Проблеми параметрів апаратного забезпечення
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e27450" title="Проблеми з витратними матеріалами">
      Проблеми з витратними матеріалами
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e27598" title="Проблеми з подачею паперу">
      Проблеми з подачею паперу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e27792" title="Проблеми з якістю друку">
      Проблеми з якістю друку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_uk" title="Звернення до служби підтримки клієнтів">
      Звернення до служби підтримки клієнтів
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_uk" title="Переробка й утилізація">
     Переробка й утилізація
    </a>
   </p>
   <div id="divd0e28016">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_uk" title="Переробка виробів Lexmark">
      Переробка виробів Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_uk" title="Переробка пакування Lexmark">
      Переробка пакування Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_uk" title="Сповіщення">
     Сповіщення
    </a>
   </p>
   <div id="divd0e28050">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28053" title="Інформація про виріб">
      Інформація про виріб
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28070" title="Сповіщення про випуск">
      Сповіщення про випуск
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_uk" title="Торгові марки">
      Торгові марки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_uk" title="Сповіщення про ліцензію">
      Сповіщення про ліцензію
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_uk" title="Рівні шуму">
      Рівні шуму
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_uk" title="Директива щодо відпрацьованого електричного й електронного обладнання (WEEE)">
      Директива щодо відпрацьованого електричного й електронного обладнання (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28168" title="Літій-іонний акумулятор із перезарядкою">
      Літій-іонний акумулятор із перезарядкою
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_uk" title="Регламент (ЄС) 2023/1542">
      Регламент (ЄС) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28205" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_uk" title="Утилізація виробу">
      Утилізація виробу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_uk" title="Сповіщення про статичну чутливість">
      Сповіщення про статичну чутливість
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_uk" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_uk" title="Інформація про температуру">
      Інформація про температуру
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_uk" title="Сповіщення про лазер">
      Сповіщення про лазер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_uk" title="Споживання електроенергії">
      Споживання електроенергії
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28448" title="Сповіщення про нормативні вимоги до бездротових виробів">
      Сповіщення про нормативні вимоги до бездротових виробів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_uk" title="Повідомлення про модульний компонент">
      Повідомлення про модульний компонент
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_uk" title="Потрапляння під вплив радіочастотного випромінювання">
      Потрапляння під вплив радіочастотного випромінювання
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28473" title="Відповідність директивам Європейського співтовариства (ЄС)">
      Відповідність директивам Європейського співтовариства (ЄС)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_uk" title="Відповідність директивам Європейського співтовариства (ЄС)">
      Відповідність директивам Європейського співтовариства (ЄС)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_uk" title="Повідомлення про радіоперешкоди">
      Повідомлення про радіоперешкоди
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue